import React from "react";
import { showAllOrdersBrand } from "~/cores/brandDataCore";
import getServerSideProps from "~/app/getServerSideProps";
import AllOrdersReturnPage from "./AllOrdersReturnPage";
import ReturnPage from "./ReturnPage";

function ReturnIndexPage(props) {
    if (showAllOrdersBrand(props)) {
        return <AllOrdersReturnPage {...props} />;
    } else {
        return <ReturnPage {...props} />;
    }
}

export { getServerSideProps };
export default ReturnIndexPage;
